import { render, staticRenderFns } from "./SharedFolderView.vue?vue&type=template&id=2dc270d6&"
import script from "./SharedFolderView.vue?vue&type=script&lang=ts&"
export * from "./SharedFolderView.vue?vue&type=script&lang=ts&"
import style0 from "./SharedFolderView.vue?vue&type=style&index=0&id=2dc270d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports